import { render, staticRenderFns } from "./ListJigyosho.vue?vue&type=template&id=1cadcb28&"
import script from "./ListJigyosho.vue?vue&type=script&lang=ts&"
export * from "./ListJigyosho.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports